import { Test, TestResult, UserResponse } from '../types/tests';

export const calculateTestResult = (
    test: Test,
    totalScore: number,
    userResponses?: UserResponse[]
): TestResult => {
    // Handle tests without interpretations (like CCQ)
    // Handle tests without interpretations (like CCQ)
    // But allow if we have subscales which have their own interpretations
    const hasInterpretations = test.interpretations && test.interpretations.length > 0;
    const hasSubscales = test.subscales && test.subscales.length > 0;

    if (!hasInterpretations && !hasSubscales) {
        return {
            testId: test.id,
            testTitle: test.title,
            totalScore,
            category: '',
            interpretation: '',
            longDescription: '',
            completedAt: new Date().toISOString(),
            userResponses,
            test,
        };
    }

    // Handle subscales
    let subScores = undefined;
    if (test.subscales && test.subscales.length > 0) {
        subScores = test.subscales.map(subscale => {
            const subscaleQuestions = test.questions.filter(q => q.subscale === subscale.id);
            const subscaleScore = userResponses?.reduce((score, response) => {
                const question = subscaleQuestions.find(q => q.id === response.questionId);
                if (question) {
                    const answer = question.answers.find(a => a.id === response.answerId);
                    return score + (answer?.score || 0);
                }
                return score;
            }, 0) || 0;

            const subscaleInterpretation = subscale.interpretations.find(
                (interp) => subscaleScore >= interp.minScore && subscaleScore <= interp.maxScore
            );

            return {
                subscaleId: subscale.id,
                subscaleTitle: subscale.title,
                score: subscaleScore,
                category: subscaleInterpretation?.category || '',
                interpretation: subscaleInterpretation?.description || '',
                longDescription: subscaleInterpretation?.longDescription || '',
            };
        });
    }

    // Main interpretation (fallback or total score interpretation)
    let category = '';
    let interpretationText = '';
    let longDescription = '';

    if (test.interpretations && test.interpretations.length > 0) {
        const interpretation = test.interpretations.find(
            (interp) => totalScore >= interp.minScore && totalScore <= interp.maxScore
        );
        if (interpretation) {
            category = interpretation.category;
            interpretationText = interpretation.description;
            longDescription = interpretation.longDescription;
        }
    }

    return {
        testId: test.id,
        testTitle: test.title,
        totalScore,
        category,
        interpretation: interpretationText,
        longDescription,
        completedAt: new Date().toISOString(),
        userResponses,
        test,
        subScores,
    };
};
